module.exports = __webpack_public_path__ + "img/ys.53f10b1a.jpg";